var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab-content-loader"},[_c('div',{staticClass:"tab-content-loader__header"},[_c('div',[_c(_setup.HeaderTitleLoader),_c(_setup.HeaderSubtitleLoader,{staticClass:"tab-content-loader__header__subtitle"})],1),_c('div',[_c(_setup.HeaderFilterLoader)],1)]),_c('div',[_c(_setup.DataTableLoader)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }